import { useSelector } from 'react-redux';
import { selectors } from 'services/user';

import useDialog from 'lib/hooks/useDialog';
import useCreateRequest from '../../SchedulePage/hooks/useCreateRequest';



function useAddAppointmentDialog() {
  const user = useSelector(selectors.getUser);

  const { onCreateAppointment } = useCreateRequest();

  const appointmentDialog = useDialog();

  async function onOpenAppointmentDialog(patient: any) {
    const result = await appointmentDialog.open({ patient: patient, user });

    if (!result?.record) {
      return;
    }

    onCreateAppointment(result);
  }

  return {
    appointmentDialog,
    onOpenAppointmentDialog
  }
}

export default useAddAppointmentDialog
